import React, { useEffect } from "react";
import { remove, values } from "lodash";
import { useImmer } from "use-immer";
import { FoodDto } from "../../api";
import { PersonLookup } from "../../data/lookups";
import { PersonChoiceModification } from "../../data/dishModification";
import { formatFoodDescription, getFoodMaybe } from "../../utils/foodUtils";
import { getRenderKey } from "../../utils/renderUtils";
import { Checkbox } from "../ui/Checkbox";
import { SaveButton } from "../buttons/SaveButton";
import {
  Plan2PlateDrawer,
  Plan2PlateDrawerHeader,
} from "../Plan2PlateDrawer";

export const PersonChoiceDrawer = (props: {
  onClose: () => void;
  open: boolean;
  personLookup: PersonLookup;
  personChoices: PersonChoiceModification[];
  submitSelectedPersons: (personIds: number[], forUnit: number) => void;
  foods: FoodDto[];
  ingredientUnit: number | undefined;
  alternativeUnit: number | undefined;
}) => {
  useEffect(() => {
    setSelectedPersons(props.personChoices.map((c) => c.personId));
  }, [props.personChoices]);
  const [selectedPersons, setSelectedPersons] = useImmer<number[]>([]);
  if (!props.ingredientUnit) {
    return <></>;
  }
  const ingredientUnit = getFoodMaybe(props.ingredientUnit, props.foods);
  const alternativeUnit = props.alternativeUnit
    ? getFoodMaybe(props.alternativeUnit, props.foods)
    : undefined;
  const description = alternativeUnit
    ? `Bei wem muss die Alternative ${formatFoodDescription(alternativeUnit)} statt ${formatFoodDescription(ingredientUnit)} als Hauptvariante verwendet werden?`
    : `Bei wem sollen abweichende Mengen für ${formatFoodDescription(ingredientUnit)} gesetzt werden?`;
  return (
    <Plan2PlateDrawer
      onClose={props.onClose}
      open={props.open}
      header={<Plan2PlateDrawerHeader heading={"Abweichende Menge"} />}
      body={
        <div className="flex flex-col items-stretch gap-3">
          <p className="text-sm text-ink-muted">{description}</p>
          {values(props.personLookup)
            .filter((p) => p.active)
            .map((p, i) => (
              <label
                key={getRenderKey(p, i)}
                className="flex cursor-pointer items-center gap-3 rounded-card border border-line bg-surface-card p-3"
              >
                <Checkbox
                  checked={selectedPersons.includes(p.id)}
                  onCheckedChange={(checked) =>
                    setSelectedPersons((draft) => {
                      if (checked) draft.push(p.id);
                      else remove(draft, (sP) => sP === p.id);
                    })
                  }
                />
                <span className="text-sm text-ink">{p.name}</span>
              </label>
            ))}
        </div>
      }
      footer={
        <div className="flex w-full items-center justify-center">
          <SaveButton
            save={async () => {
              props.submitSelectedPersons(
                selectedPersons,
                props.alternativeUnit || props.ingredientUnit!,
              );
              props.onClose();
              return false;
            }}
          />
        </div>
      }
    />
  );
};
